import H1 from './H1.png'
import H2 from './H2.png'
import H20 from './MAS Logo.png'
import H21 from './Connex logo.png'
import H3 from './H3.png'
import H4 from './H4.png'
import H5 from './H5.png'
import H6 from './H6.png'
import H7 from './H7.jpeg'
import L11 from './11L.jpg'
import MITLogo from './MIT Logo.png'
import binaru from './binaru.jpeg'
import chatuni from './chatuni.jpeg'
import dila from './dila.png'
import dilu from './dilu.jpg'
import dipa from './dipa.jpg'
import email from './email.png'
import ex from './Expo.png'
import expo from './expologo.png'
import facebook_icon from './facebook_icon.png'
import ga1 from './ga1.jpg'
import ga10 from './ga10.jpg'
import ga11 from './ga11.jpg'
import ga12 from './ga12.jpg'
import ga13 from './ga13.jpg'
import ga14 from './ga14.jpg'
import ga15 from './ga15.jpg'
import ga16 from './ga16.jpg'
import ga17 from './ga17.jpg'
import ga18 from './ga18.jpg'
import ga19 from './ga19.jpg'
import ga2 from './ga2.jpg'
import ga20 from './ga20.jpg'
import ga3 from './ga3.jpg'
import ga4 from './ga4.jpg'
import ga5 from './ga5.jpg'
import ga6 from './ga6.jpg'
import ga7 from './ga7.jpg'
import ga8 from './ga8.jpg'
import ga9 from './ga9.jpg'
import kasun from './Kasun_Kalhara.jpg'
import kau from './kau.jpeg'
import kezara from './kezara.jpeg'
import lakma from './lakma.jpeg'
import linkedin_icon from './linkedin_icon.png'
import meshel from './mishel.jpeg'
import nadi from './nadi.jpg'
import nadun from './nadu.jpeg'
import pasi from './pasidu.jpeg'
import pavitra from './pavitra.jpeg'
import phone from './phone.png'
import samoda from './samoda.jpeg'
import san from './sandra.png'
import senudha from './senuda.jpeg'
import shashika from './shashika.jpeg'
import shehara from './shehara.jpeg'
import t from './t.jpeg'
import teki from './teki.jpeg'
import twitter_icon from './twitter_icon.png'
import unilogo from './unilogo.png'
import up from './up.png'
import x1 from './x1.jpg'
import x2 from './x2.jpg'
import x3 from './x3.jpg'
import xx from './xx.jpg'
import xxback from './xxback.jpg'

export const  assest = {
    expo,MITLogo,email,phone,facebook_icon,twitter_icon,linkedin_icon,H1,H2,H3,up,H5,H4,H6,H7,unilogo,
    L11,H20,H21,xx,x1,x2,x3,xxback,kasun,ex,ga1,ga2,ga3,ga4,ga5,ga6,ga7,ga8,ga9,ga10,ga11,ga12,ga13,ga14,ga15,ga16,ga17,ga18,ga19,ga20,
    senudha,shehara,shashika,teki,chatuni,samoda,pavitra,meshel,lakma,kezara,binaru,dipa,nadi,san,dilu,dila,t,nadun,kau,pasi
}

